import ImageItemAsset from 'models/store/itemAsset/ImageItemAsset';

import ItemAssetBaseService from 'services/store/itemAsset/ItemAssetBaseService';

export default class ImageItemAssetService extends ItemAssetBaseService {
	toModel(asset) {
		return new ImageItemAsset(asset);
	}
}
